import React from 'react'
import { connect } from 'react-redux'

const OrganizationList = ({ teamId, members, users }) => (
  <div>
    {members?
      members.map(uid => {
        return (
          <div key={teamId + uid} className="member">
            <div className="image">
            {users[uid].images? 
              <img src={users[uid].images.x48} alt={users[uid].realName} /> 
            : 
              <i className="fas fa-user no-image"></i>
            }
            </div>
            <div>
              <p className="position">{users[uid].position? users[uid].position : "　"}</p>
              <p>{users[uid].realName}{users[uid].nickName? " (" + users[uid].nickName + ")" : ""}</p>
            </div>
          </div>
        )
      })
    :
      null
    }
  </div>
)

export default connect(
  state => ({
    users: state.users
  })
)(OrganizationList)



// WEBPACK FOOTER //
// ./src/components/OrganizationList.js